import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Get navbar height dynamically
    const navbar = document.querySelector('header');
    const navbarHeight = navbar ? navbar.offsetHeight : 0;
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    
    // Then adjust for navbar
    if (navbarHeight > 0) {
      window.scrollTo({
        top: -navbarHeight,
        left: 0,
        behavior: 'auto'
      });
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;